
import throttle from '../../00-base/global/utils/throttle';
import debounce from '../../00-base/global/utils/debounce';


/* From https://github.com/three11/scrollspy/blob/master/src/scrollspy.js, but modified. */

/**
 * ScrollSpy
 */
export default class ScrollSpy  {
  /**
   * Create an instance
   *
   * @param  {Object} settings
   *
   * @return {Object} ScrollSpy instance
   */
  constructor(settings = {}) {
    const options = Object.assign({
      sectionSelector: '.js-scroll-spy-section',
    }, settings);

    this.init(options);

    window.addEventListener('load', this.refreshPositions.bind(this));
    window.addEventListener('resize', this.refreshPositions.bind(this));

    return this;
  }

  /**
   * Initialize the plugin
   *
   * @param  {Object} options
   *
   * @return {Void}
   */
  init(options) {
    // Prepare properties
    this.setProperties(options);

    // Fire up plugin
    this.getSectionData();
    this.lastHeight = document.body.clientHeight;

    const hashIndex = this.getIndexFromHash(options.initHash);
    const initIndex = hashIndex;
    this.updateCurrentSectionIndex(initIndex, true, 'init');
    this.bindEvents();
  }

  /**
   * 
   * @param {string} hash Hash of section that is currently loaded
   */
  getIndexFromHash(hash) {
    return hash && this.data.hashIds && hash in this.data.hashIds ? this.data.hashIds[hash] : -1;

  }

  /**
   * Set plugin's properties
   *
   * @return {Void}
   */
  setProperties(options) {
    const doc = document;

    this.sectionSelector = options.sectionSelector;
    this.sections = [...doc.querySelectorAll(this.sectionSelector)];
    
    this.currentIdx = 0;
    this.data = {
      offsets: [],
      ids: [],
      hashIds: {}
    };

    this.scrollUpdateChecker = options.documentScroller.scrollUpdateChecker;
    this.headerHeightCalculator = options.documentScroller.headerHeightCalculator;
    this.documentScroller = options.documentScroller;
    this.updateSectionCallback = options.updateSectionCallback
  }

  /**
   * Calculate fixed header offset
   * @return {Double}
   */

   /**
    * @return {number}  height of fixed header on the page. This triggers a calculation which
    * may involve DOM calls.
    */
  getHeaderOffset() {
    const fixedHeight =this.headerHeightCalculator.getFullHeaderHeight();
    return fixedHeight;

  }

  /** Calculate situational offset, based on the state of the page and whether click is moving up or down. */
  getSituationalOffset(options) {
    const isMovingDown = options ? options.isMovingDown : this.isMovingDown;
    return documentScroller.getSituationalOffset(isMovingDown);
  }

  /**
   * Prepare the data for the sections
   *
   * @return {Void}
   */
  getSectionData() {

    const currentHeaderOffset = this.getHeaderOffset();
    this.sections.forEach((section, i) => {
      const id = section.getAttribute('id');
      this.data.ids.push(id);
      this.data.offsets.push(this.getElementOffset(section, currentHeaderOffset));
      if (id) {
        this.data.hashIds[`#${id}`] = i;
      }
    });
  }

  /**
   * Update the data for the sections
   *
   * @return {Void}
   */
  refreshPositions() {
    const currentHeaderOffset = this.getHeaderOffset();
    this.data.offsets = this.data.offsets.map((offset, index) => {
      return this.getElementOffset(this.sections[index], currentHeaderOffset);
    });
  }

  /**
   * Get the top offset of a section
   *
   * @param  {<DOM Element>Object} element
   * @param {Double} currentHeaderOffset
   *
   * @return {Number}
   */
  getElementOffset(element, currentHeaderOffset) {


    if (!element || !element.getBoundingClientRect) {
      return 0;
    }

  

    const clientRect = element.getBoundingClientRect();
    const offsetTop = clientRect.top + window.pageYOffset;
    const padding = 50;

    return offsetTop - currentHeaderOffset - padding;
  }

  /** Update current index 
   * @param {number} index  The index to set
   * @param {boolean} overrideCurrent true if the code should run even if index is the same as current index. Default is false.
   * @return {Void}
   * 
  */
updateCurrentSectionIndex(index, overrideCurrent = false, desc='') {
  
  if (overrideCurrent || index !== this.currentIdx) {
      this.currentIdx = index;
      const hash = this.currentIdx > -1 && this.data.ids[this.currentIdx] ? `#${this.data.ids[this.currentIdx]}` : null;
      const sectionUpdateDetail = {
        index: index,
        hash: hash,
        src: `spy-${desc}`
      };

      if (this.updateSectionCallback) {
        this.updateSectionCallback(sectionUpdateDetail);
      }
  }
}

  /**
   * Find the index of the current section
   *
   * @return {Int} index of current section
   */
  getCurrentSectionIndex() {
    const scrollTop = window.pageYOffset;
    for (let i = 0; i < this.data.offsets.length; i++) {
      const offset = this.data.offsets[i];
      const nextOffset = this.data.offsets[i+1] || null;

      if (scrollTop >= offset && (nextOffset === null || scrollTop < nextOffset)) {
        return i;
      }

    }
    return -1; 
  }
  

  /**
   * Updates current section info based on state of page
   */
  sync() {
    this.updateCurrentSectionIndex(this.getCurrentSectionIndex(), false, 'sync');
  }

  /**
   * Bind the events
   *
   * @return {Void}
   */
  bindEvents() {
    const win = window;

    setTimeout(() => { win.addEventListener('scroll', throttle(() => {
      if (document.body.clientHeight !== this.lastHeight) {
        this.refreshPositions();
        this.lastHeight = document.body.clientHeight;
      }
      if (this.scrollUpdateChecker.checkScrollUpdate()) {
       this.sync();
      }
    }, 100), {passive: true})}, 10);
  }


}
